import React from "react";
import { Create, translate } from "react-admin";
import InterestingForm from "./InterestingForm";

const InterestingTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("interesting.interesting")}`}</span>;
};

const Title = translate(InterestingTitle);

export const InterestingCreate = props => (
  <Create title={<Title />} {...props}>
    <InterestingForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/interesting/InterestingCreate.js